import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, AlertTriangle, Heart, Shield, Flame, Cross, Anchor, Phone, MapPin, Loader2 } from 'lucide-react';
import { useLang } from '../i18n';
import { publicApi, resolveImage } from '../api';
import { useFetch } from '../useFetch';

const ICONS = { AlertTriangle, Heart, Shield, Flame, Cross, Anchor };

export default function Emergency() {
  const loc = useLocation();
  const slug = loc.pathname.split('/').filter(Boolean)[0];
  const { lang, t } = useLang();
  const nav = useNavigate();
  const { data: city } = useFetch(`city:${slug}`, () => publicApi.city(slug), [slug]);
  const { data: contacts, loading } = useFetch(`emg:${slug}`, () => publicApi.emergency(slug), [slug]);

  if (loading || !city || !contacts) return <div className="flex justify-center py-32"><Loader2 className="animate-spin text-gray-400" size={40} /></div>;

  return (
    <div>
      <section className="relative" style={{ minHeight: '35vh' }}>
        <div className="absolute inset-0"><img src={resolveImage(city.services?.emergency || city.hero)} alt="" className="w-full h-full object-cover" /><div className="absolute inset-0 bg-gradient-to-b from-red-900/60 to-red-950/70" /></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-white text-center px-6" style={{ minHeight: '35vh' }}>
          <AlertTriangle size={44} className="mb-3 fade-in-up" />
          <h1 className="text-3xl md:text-5xl font-bold tracking-wider fade-in-up fade-in-up-delay-1">{t('emergency')}</h1>
          <p className="mt-2 text-sm tracking-widest uppercase opacity-90 fade-in-up fade-in-up-delay-2">{city.full_name?.[lang] || city.name}</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {contacts.map((c, idx) => {
            const Icon = ICONS[c.icon] || Phone;
            return (
              <a key={c.id || idx} href={`tel:${c.phone.replace(/\s/g, '')}`} className="group flex items-start gap-4 bg-white border border-gray-200 rounded-lg p-5 hover:border-[color:var(--yup-primary)] hover:shadow-lg transition-all fade-in-up" style={{ animationDelay: `${0.05 + idx * 0.06}s` }}>
                <div className="shrink-0 w-12 h-12 rounded-full bg-[color:var(--yup-primary)]/10 flex items-center justify-center text-[color:var(--yup-primary)] group-hover:bg-[color:var(--yup-primary)] group-hover:text-white transition-colors"><Icon size={22} /></div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-0.5">{c.name?.[lang] || c.name?.en}</h3>
                  <div className="flex items-center gap-1.5 text-lg font-bold text-[color:var(--yup-primary)]"><Phone size={16} /> {c.phone}</div>
                  {c.address && <div className="flex items-center gap-1.5 text-xs text-gray-500 mt-1"><MapPin size={12} /> {c.address}</div>}
                </div>
              </a>
            );
          })}
        </div>
        <div className="mt-12 text-center">
          <button onClick={() => nav(`/${slug}`)} className="inline-flex items-center gap-2 text-[color:var(--yup-primary)] font-semibold hover:underline"><ArrowLeft size={16} /> {city.full_name?.[lang] || city.name}</button>
        </div>
      </section>
    </div>
  );
}
